import { render, staticRenderFns } from "./BlocksMenu.vue?vue&type=template&id=02716f2c&scoped=true&"
import script from "./BlocksMenu.vue?vue&type=script&lang=js&"
export * from "./BlocksMenu.vue?vue&type=script&lang=js&"
import style0 from "./BlocksMenu.vue?vue&type=style&index=0&id=02716f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02716f2c",
  null
  
)

export default component.exports